import React from 'react';
import './budget-impacts-page.m.css';

const getCardColor = (percent, maxPositive, maxNegative) => {
  if (percent === 0) return '#3A3A3A';
  if (percent > 0) {
    const intensity = maxPositive !== 0 ? Math.abs(percent) / Math.abs(maxPositive) : 0;
    const green = Math.round(235 - intensity * 155);
    return `rgb(0,${green},0)`;
  }
  const intensity = maxNegative !== 0 ? Math.abs(percent) / Math.abs(maxNegative) : 0;
  const red = Math.round(235 - intensity * 135);
  return `rgb(${red},0,0)`;
};

const renderCards = (cardsData, takeToPage, component = '', sortOrder = 'low-to-high' ) => {
  const percentField = component === 'heatmap-sector-page' ? 'sectorPercentChange' : 'changePer';
  const nameField = component === 'heatmap-sector-page' ? 'sectorName' : 'name';

  const clickOnCard = (card) => {
    if (component === 'heatmap-sector-page') {
      takeToPage(card);
    } else {
      takeToPage(card?.exchangeSymbol, card?.entityId);
    }
  };

  const maxPositive = Math.max(0, ...cardsData.map((c) => c[percentField]));
  const maxNegative = Math.min(0, ...cardsData.map((c) => c[percentField]));

  let sortedData;
  if (sortOrder === 'low-to-high') {
    sortedData = cardsData.slice().sort((a, b) => b[percentField] - a[percentField]);
  } else {
    sortedData = cardsData.slice().sort((a, b) => a[percentField] - b[percentField]);
  }
  return sortedData
    .map((card, index) => {
      const bgColor = getCardColor(card[percentField], maxPositive, maxNegative);
      const name = !!card[nameField] ? card[nameField] : !!card?.exchangeSymbol ? card?.exchangeSymbol : card?.isin;
      return (
        <div
          styleName={`card`}
          key={name.replace(/\s/g, '_') + '_' + index}
          role="button"
          style={{
            background: `${bgColor} 0 0 no-repeat padding-box`,
          }}
        >
          <div
            styleName="stock-name"
            title={name}
            onClick={() => clickOnCard(card)}
          >
            {name}
          </div>
          <div styleName="price-ctx">
            {component !== 'heatmap-sector-page' && (
              <span styleName="current-price">{card.lastPrice}</span>
            )}
            <div styleName={`change-ctx ${component === 'heatmap-sector-page' ? 'ml-0' : ''}`}>
              {card[percentField] !== 0 && (
                <span styleName={`change-symbol ${card[percentField] < 0 ? 'negative-change' : ''}`}>
                  {card[percentField] < 0 ? '▼' : '▲'}
                </span>
              )}
              <span styleName={`change-perc ${card[percentField] === 0 ? 'no-change' : ''}`}>
                {card[percentField]}%
              </span>
            </div>
          </div>
        </div>
      );
    });
};

export default renderCards;
